export const environment = {
  production: true,
  apiUrl: '/api/',
  webSocket: 'wss://' + window.location.host + '/api/ws/start',
};
